import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../components/form/FormInput';
import { inputTypes } from '../../components/form/FormInput/util';
import { createErrorToast, createSuccessToast } from '../../redux/modules/app';
import { hideModal } from '../../redux/modules/modal';
import { useUpdateUser } from '../../services/user-service';
import { removePhoneNumberFormat } from '../../utils/formatPhoneUtil';

const EditUserModal = ({ user }) => {
  const dispatch = useDispatch();

  const { mutateAsync: updateUser } = useUpdateUser();

  const useFormMethods = useForm({
    defaultValues: {
      user_email: user?.userEmail,
      user_first_name: user?.userFirstName,
      user_last_name: user?.userLastName,
      user_phone: user?.userPhone
    }
  });

  const { handleSubmit } = useFormMethods;

  const onSubmit = async data => {
    try {
      await updateUser({
        userId: user.userId,
        user_email: data.user_email,
        user_first_name: data.user_first_name,
        user_last_name: data.user_last_name,
        user_phone: removePhoneNumberFormat(data.user_phone)
      });

      dispatch(createSuccessToast({ title: 'User updated successfully' }));
      dispatch(hideModal());
    } catch (error) {
      dispatch(createErrorToast({
        title: 'Oops! Something went wrong...',
        description: 'Your user was not updated successfully.',
        error
      }));
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text mb={2} textStyle="bodyLg500">Contact Info</Text>

        <HStack alignItems="flex-start" justifyContent="space-between" spacing={4}>
          <Box flexBasis="50%">
            <FormInput
              inputName="user_email"
              labelName="Email"
              useFormMethods={useFormMethods}
            />
            <FormInput
              inputName="user_first_name"
              labelName="First Name"
              useFormMethods={useFormMethods}
            />
          </Box>

          <Box flexBasis="50%">
            <FormInput
              inputName="user_last_name"
              labelName="Last Name"
              useFormMethods={useFormMethods}
            />
            <FormInput
              inputName="user_phone"
              labelName="Phone"
              type={inputTypes.phoneNumber}
              useFormMethods={useFormMethods}
            />
          </Box>
        </HStack>

        <HStack justifyContent="center" mt={4} spacing={4}>
          <Button variant="secondary" onClick={() => dispatch(hideModal())}>
            Cancel
          </Button>

          <Button type="submit">
            Save
          </Button>
        </HStack>
      </form>
    </Box>
  );
};

EditUserModal.propTypes = { user: PropTypes.object.isRequired };

export default EditUserModal;
